import React from "react";
//#region types
import { SupportTeamMember } from "serviceHooks/useSupportTeamContent";
//#endregion
import cssExports from "theme/styles/main.module.scss";

interface TeamAvatarGroupProps {
  members: SupportTeamMember[];
  max?: number;
}

const TeamAvatarGroup: React.FC<TeamAvatarGroupProps> = ({ members, max = 3 }) => {
  if (!members.length) return null;

  return (
    <div className={cssExports.supportTeamAvatarGroup}>
      {members.slice(0, max).map((member, index) => (
        <div key={`${member.imageUrl || member.name}-${index}`} className={cssExports.supportTeamAvatar}>
          {member.imageUrl ? (
            <img src={member.imageUrl} alt={member.name} />
          ) : (
            <div className={cssExports.supportTeamAvatarPlaceholder}>{member.name.charAt(0)}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default TeamAvatarGroup;
